import { Pet } from 'types/Pet';

export interface PetsState {
    pet?: Pet;
    loading: boolean;
    status: PetsStatus;
}

export enum PetsStatus {
    Initial,

    SaveStart,
    SaveSuccess,

    Error
}
